import styled from 'styled-components';

const Wrapper = styled.div`
display:block;
padding: 20px;
margin-top:50px;
-webkit-user-select: none;
-khtml-user-select: none;
-moz-user-select: none;
-o-user-select: none;
user-select: none;
user-drag: none;
-webkit-user-drag: none;
`
const BigTitle = styled.div`
font-size: 2.5rem;
color: ${props => props.theme.colors.brown};;
`
const SmallTitle = styled.div`
font-size: 1.4rem;
color: ${props => props.theme.colors.orange};;
`
const ImgLogo = styled.img`
float:left;
-webkit-user-select: none;
-khtml-user-select: none;
-moz-user-select: none;
-o-user-select: none;
user-select: none;
user-drag: none;
-webkit-user-drag: none;
margin-right: 30px;
`
const TextWrapper = styled.div`
margin-top:20px;
margin-bottom: 20px;
`

const Logo = () => {

    return (
    <Wrapper>
        <a href="https://www.mom.fr" target="_blank" rel="noreferrer"><ImgLogo src="/img/momLogo.png"></ImgLogo></a>
        <TextWrapper>
            <BigTitle>TheatraData</BigTitle>
            <SmallTitle>Gestion des données du projet THEATRA</SmallTitle>
        </TextWrapper>
    </Wrapper>
    )
}

export default Logo;